import { render, staticRenderFns } from "./DetailPrintPage.vue?vue&type=template&id=2088ceee&scoped=true&"
import script from "./DetailPrintPage.vue?vue&type=script&lang=ts&"
export * from "./DetailPrintPage.vue?vue&type=script&lang=ts&"
import style0 from "./DetailPrintPage.vue?vue&type=style&index=0&id=2088ceee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2088ceee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
